import React from 'react';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import {
  KeyboardAvoidingView,
} from 'react-native';
import {
  Button,
  Icon,
  Input,
  Text,
} from 'react-native-elements';
import { Formik } from 'formik';
import { object as yupObject } from 'yup';
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view';
import Header from '../../misc/Header';

import { translate } from '../../../locales/i18n';
import styles from '../../../styles';
import { emailValidation, codeValidation } from '../../../modules/validation/User';

const validationSchema = yupObject().shape({
  email: emailValidation,
  code: codeValidation,
});

class SignConfirmForm extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.handleSubmit = this.handleSubmit.bind(this);

    this.state = {};
  }

  async handleSubmit(values, formikBag) {
    formikBag.setSubmitting(true);
    this.setState({ error: undefined });

    const { onSubmit } = this.props;
    const err = await onSubmit(values);
    if (err !== null) {
      // FIXME(clairbee): 'status' does not get updated. 'formikBag' might be stale.
      formikBag.setStatus(err);
      this.setState({ error: err });
    }

    formikBag.setSubmitting(false);
  }

  renderForm = ({
    isValid,
    values,
    handleSubmit,
    setFieldValue,
    touched,
    errors,
    setFieldTouched,
    isSubmitting,
    // status,
  }) => {
    const { history } = this.props;
    const { error } = this.state;

    return (
      <KeyboardAvoidingView
        style={[
          styles.view.form,
          {
            backgroundColor: 'white',
            width: '100%',
            padding: 0,
            margin: 0,
            alignItems: 'center',
            justifyContent: 'space-evenly',
          },
        ]}
        behavior="padding"
      >
        <Header
          name={translate('menu_confirm')}
          hasCancel
          history={history}
        />

        <KeyboardAwareScrollView
          style={{
            flex: 1,
            width: '100%',
            margin: 0,
          }}
          contentContainerStyle={{
            width: '100%',
            padding: 0,
            alignItems: 'center',
            justifyContent: 'space-evenly',
            paddingBottom: 20,
          }}
        >
          <Text
            style={{
              fontSize: 16,
              margin: 20,
            }}
          >
            {translate('confirm_intro')}
          </Text>
          {error !== undefined && (
            <Text
              style={{
                color: 'red',
              }}
            >
              {error}
            </Text>
          )}
          <Input
            label={translate('signin_email')}
            containerStyle={styles.form.inputContainer}
            labelStyle={styles.form.inputLabel}
            inputStyle={styles.form.inputInput}
            inputContainerStyle={touched.email && errors.email ? styles.form.inputInputContainerError : styles.form.inputInputContainer}
            leftIconContainerStyle={styles.form.inputIconContainer}
            value={values.email}
            placeholder={translate('signin_email_placeholder')}
            autoCompleteType="email"
            textContentType="emailAddress"
            importantForAutofill="yes"
            Icon={(
              <Icon
                name="user"
                type="font-awesome"
                size={16}
                color={styles.form.inputLabel.color}
              />
            )}
            keyboardType="email-address"
            autoCapitalize="none"
            autoFocus
            onChangeText={(value) => setFieldValue('email', value)}
            onBlur={() => setFieldTouched('email')}
            editable={!isSubmitting}
            errorMessage={touched.email && errors.email ? errors.email : undefined}
          />
          <Input
            label={translate('confirm_code')}
            containerStyle={styles.form.inputContainer}
            labelStyle={styles.form.inputLabel}
            inputStyle={styles.form.inputInput}
            inputContainerStyle={touched.code && errors.code ? styles.form.inputInputContainerError : styles.form.inputInputContainer}
            placeholder={translate('confirm_code_placeholder')}
            autoCapitalize="none"
            value={values.code}
            onChangeText={(value) => setFieldValue('code', value)}
            onBlur={() => setFieldTouched('code')}
            editable={!isSubmitting}
            errorMessage={touched.code && errors.code ? errors.code : undefined}
          />
          <Button
            title={translate('button_verify')}
            containerStyle={[styles.buttonfsf.primaryContainer, { marginTop: 30 }]}
            buttonStyle={styles.buttonfsf.primary}
            disabledStyle={styles.buttonfsf.primaryDisabled}
            titleStyle={styles.buttonfsf.primaryTitle}
            disabledTitleStyle={styles.buttonfsf.primaryTitleDisabled}
            onPress={handleSubmit}
            disabled={!isValid || isSubmitting}
            loading={isSubmitting}
            loadingProps={{ size: 'small', color: 'white' }}
          />
          {/* <Button
            clear
            title={translate('button_cancel')}
            containerStyle={[styles.buttonfsf.secondaryContainer, { marginTop: 20 }]}
            buttonStyle={styles.buttonfsf.secondary}
            titleStyle={styles.buttonfsf.secondaryTitle}
            onPress={() => history.push('/ai-agents')}
          /> */}
        </KeyboardAwareScrollView>
      </KeyboardAvoidingView>
    );
  };

  render() {
    const { email } = this.props;

    return (
      <Formik
        enableReinitialize
        initialValues={{ email, code: '' }}
        onSubmit={this.handleSubmit}
        validationSchema={validationSchema}
      >
        {this.renderForm}
      </Formik>
    );
  }
}

SignConfirmForm.propTypes = {
  email: PropTypes.string.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default SignConfirmForm;
